import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "src/redux/actions/auth";
import { Progress } from "antd";
import swal from "sweetalert";

function Logout() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [percent, setPercent] = useState(10);

  useEffect(() => {
    setPercent(30);
    dispatch(logout());
    swal("Success", "successfuly signed out", "success", {
      buttons: false,
      timer: 2000,
    });
    setPercent(70);
    window.setTimeout(() => {
      setPercent(100);
      navigate("/");
    }, 2000);
  }, []);
  return <Progress percent={percent} showInfo={false} size="small" />;
}

export default Logout;
